import React from "react";
import "./App.css";

function App() {
  return (
    <main
      data-testid="coming-soon-container"
      className="residense-gradient-bg min-h-screen min-h-[100dvh] w-full flex flex-col items-center justify-center px-6 py-12 select-none"
    >
      <div className="w-full max-w-5xl mx-auto flex flex-col items-center justify-center text-center">
        {/* Residense Logo with separate TM Superscript */}
        <div
          data-testid="logo-wrapper"
          className="relative inline-flex items-start justify-center mb-8 sm:mb-12 md:mb-14"
        >
          <img
            src="/residense-logo.png"
            alt="Residense"
            data-testid="residense-logo"
            className="w-[280px] xs:w-[320px] sm:w-[460px] md:w-[600px] lg:w-[720px] max-w-[90vw] h-auto object-contain select-none pointer-events-none drop-shadow-[0_12px_32px_rgba(17,9,85,0.4)]"
          />
          <span
            data-testid="trademark-superscript"
            aria-label="Trademark"
            className="absolute top-0 -right-3 sm:-right-4 md:-right-5 lg:-right-6 text-[10px] sm:text-xs md:text-sm lg:text-base font-semibold text-white/90 leading-none select-none pointer-events-none drop-shadow-sm"
          >
            ™
          </span>
        </div>

        {/* Coming Soon Heading */}
        <h1
          data-testid="coming-soon-heading"
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-5 sm:mb-6 drop-shadow-md"
        >
          Coming Soon
        </h1>

        {/* Registration of Interest / Contact Email */}
        <p
          data-testid="register-interest-text"
          className="text-base sm:text-lg md:text-xl text-white/95 font-medium max-w-2xl mx-auto leading-relaxed drop-shadow-sm px-2"
        >
          To register your interest, please email{" "}
          <a
            href="mailto:support@residense.co.nz"
            data-testid="support-email-link"
            className="email-link font-semibold whitespace-nowrap"
          >
            support@residense.co.nz
          </a>
        </p>
      </div>
    </main>
  );
}

export default App;
